// extracted by mini-css-extract-plugin
module.exports = {"TagSvg":"TagSvg_TagSvg__1VJx-","HELP":"TagSvg_HELP__EzWL-","TEACH":"TagSvg_TEACH__LXF_H","RENT":"TagSvg_RENT__O84Vu","MAKE":"TagSvg_MAKE__13ED2"};